import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProduccionService } from 'app/services/produccion.service';

@Component({
  selector: 'app-centro-costos-indirectos',
  templateUrl: './centro-costos-indirectos.component.html',
  styleUrls: ['./centro-costos-indirectos.component.scss']
})
export class CentroCostosIndirectosComponent implements OnInit {
  form: FormGroup;
  loading = false;
  base: 'unidad' | 'hora' = 'unidad';
  volumen: number = 0;
  tasaCIFCalculada: number = 0;

  constructor(
    private fb: FormBuilder, 
    private produccionService: ProduccionService,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      costos: this.fb.array([])
    });
  }

  ngOnInit() {
    this.loading = true;
    this.produccionService.getCifData().subscribe((data: any) => {
      if (data && data.cif_costos) {
        data.cif_costos.forEach((c: any) => this.costos.push(this.fb.group({ nombre: c.nombre, valor: c.valor })));
      } else {
        ['Luz', 'Gas', 'Alquiler Taller', 'Amortización Máquinas'].forEach(nombre =>
          this.costos.push(this.fb.group({ nombre, valor: 0 })));
      }
      this.base = data?.cif_base || 'unidad';
      this.volumen = data?.cif_volumen || 0;
      this.calcularTasaCIF();
      this.loading = false;
    }, () => { this.loading = false; });
  }

  get costos() {
    return this.form.get('costos') as FormArray;
  }

  agregarCosto() {
    this.costos.push(this.fb.group({ nombre: '', valor: 0 }));
  }

  eliminarCosto(i: number) {
    this.costos.removeAt(i);
    this.calcularTasaCIF();
  }

  guardar() {
    const dto = {
      cif_costos: this.costos.value,
      cif_volumen: this.volumen,
      cif_base: this.base,
      coming_from_product_detail: false
    };
    this.produccionService.saveCifData(dto).subscribe(
      (data)=> {
        this.openSnackBar(`Costos guardados correctamente`, 'Éxito');
      },
      error => {
          this.openSnackBar(`Ocurrió un error al guardar los costos`, 'Error');
      }
    );
  }

  openSnackBar(message: string, type) {
    this.snackBar.open(message, type, {
      duration: 5000,
    });
  }

  get totalCIF() {
    return this.costos.value.reduce((acc: number, c: any) => acc + Number(c.valor), 0);
  }

  actualizarBase(base: 'unidad' | 'hora') {
    this.base = base;
    this.calcularTasaCIF();
  }

  actualizarVolumen(vol: number) {
    this.volumen = vol;
    this.calcularTasaCIF();
  }

  calcularTasaCIF() {
    this.tasaCIFCalculada = this.volumen > 0 ? this.totalCIF / this.volumen : 0;
    // No guardar aquí para evitar múltiples requests innecesarios
  }

  get tasaCIF() {
    return this.tasaCIFCalculada;
  }
}
